/** Effective/policy date-range validation message. */

export const END_DATE_BEFORE_START_MESSAGE = 'End date must be on or after start date.'
